export enum ZoneErrorCodes {
  "ZONE_SERVICE_NOT_AVAILABLE_FOR_ROUTE" = "ZONE_SERVICE_NOT_AVAILABLE_FOR_ROUTE",
}
